import { render, staticRenderFns } from "./RegistryIndex.vue?vue&type=template&id=a3b49ece&"
import script from "./RegistryIndex.vue?vue&type=script&lang=js&"
export * from "./RegistryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports